import { Outlet } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { initDB } from "react-indexed-db-hook";
import { useEffect, useState, useCallback } from "react";

import { useFirebase } from "@/hooks/use-firebase";
import { useSocketReceiver } from "@/hooks/use-sockets";
import { useOnlineStatus } from "@/hooks/use-online-status";

import InstantCallNotification from "@/components/InstantCallNotification";
import ChatRequestPopup from "@/components/ChatRequestsPopup";
import NotificationPermissionBanner from "@/components/NotificationPermissionBanner";

const dbConfig = {
  name: "apna-sanatan-storage",
  version: 1,
  objectStoresMeta: [
    {
      store: "astrologer",
      storeConfig: { keyPath: "astrologerId", autoIncrement: false },
      storeSchema: [
        {
          name: "astrologerId",
          keypath: "astrologerId",
          options: { unique: true },
        },
      ],
    },
  ],
};

initDB(dbConfig);

export default function RootLayout() {
  const [activeNotification, setActiveNotification] = useState(null);
  
  useFirebase();
  
  // Initialize online status management
  useOnlineStatus();
  
  const showNotification = useCallback((props) => {
    console.log("[Partner] Received instant-call-request:", props);
    console.log(`[Partner] Call mode: ${props.mode}, User: ${props.userName}`);
    
    if (!props.mode) {
      console.error("[Partner] Missing mode in instant-call-request:", props);
      return;
    }
    
    if (props.mode !== "video" && props.mode !== "voice") {
      console.error(`[Partner] Invalid mode '${props.mode}' in instant-call-request`);
      return;
    }
    
    // Use state-based notification instead of toast
    setActiveNotification(props);
  }, []);
  
  const hideNotification = useCallback(() => {
    setActiveNotification(null);
  }, []);
  
  // Handle call interruption (user cancelled before astrologer responded)
  const handleInterruptCall = useCallback(() => {
    console.log("[Partner] Received interrupt-call - user cancelled");
    setActiveNotification(null);
    toast('Call cancelled by user', { icon: 'ℹ️' });
  }, []);
  
  useSocketReceiver("instant-call-request", showNotification);
  useSocketReceiver("interrupt-call", handleInterruptCall);

  return (
    <div className="min-h-screen">
      <NotificationPermissionBanner />
      <Outlet />
      <Toaster />
      <ChatRequestPopup />
      
      {/* State-based notification instead of toast */}
      {activeNotification && (
        <InstantCallNotification 
          {...activeNotification} 
          onDismiss={hideNotification}
        />
      )}
    </div>
  );
}
